import api from '../../../../services/api';

// Action types
export const FETCH_SHOPIFY_VARIANTS_REQUEST = 'FETCH_SHOPIFY_VARIANTS_REQUEST';
export const FETCH_SHOPIFY_VARIANTS_SUCCESS = 'FETCH_SHOPIFY_VARIANTS_SUCCESS';
export const FETCH_SHOPIFY_VARIANTS_FAILURE = 'FETCH_SHOPIFY_VARIANTS_FAILURE';

export const UPDATE_VARIANT_REQUEST = 'UPDATE_VARIANT_REQUEST';
export const UPDATE_VARIANT_SUCCESS = 'UPDATE_VARIANT_SUCCESS';
export const UPDATE_VARIANT_FAILURE = 'UPDATE_VARIANT_FAILURE';

export const BULK_UPDATE_VARIANTS_REQUEST = 'BULK_UPDATE_VARIANTS_REQUEST';
export const BULK_UPDATE_VARIANTS_SUCCESS = 'BULK_UPDATE_VARIANTS_SUCCESS';
export const BULK_UPDATE_VARIANTS_FAILURE = 'BULK_UPDATE_VARIANTS_FAILURE';

export const SET_VARIANTS_FILTERS = 'SET_VARIANTS_FILTERS';
export const SET_VARIANTS_PAGINATION = 'SET_VARIANTS_PAGINATION';

/**
 * Fetch shopify variants with filters and pagination
 */
export const fetchShopifyVariants = (page = 1, pageSize = 50) => async (dispatch, getState) => {
    try {
        dispatch({ type: FETCH_SHOPIFY_VARIANTS_REQUEST });

        const { filters } = getState().shopifyVariants;

        const params = {
            page,
            pageSize,
            ...filters
        };

        const response = await api.get('/shopify/variants', { params });

        dispatch({
            type: FETCH_SHOPIFY_VARIANTS_SUCCESS,
            payload: {
                variants: response.data.data,
                pagination: response.data.pagination
            }
        });

        return response.data;
    } catch (error) {
        dispatch({
            type: FETCH_SHOPIFY_VARIANTS_FAILURE,
            payload: error.response?.data?.message || 'Failed to fetch variants'
        });
        throw error;
    }
};

/**
 * Apply filters
 */
export const applyFilters = (filters) => async (dispatch) => {
    dispatch({
        type: SET_VARIANTS_FILTERS,
        payload: filters
    });

    // Fetch với filters mới
    dispatch(fetchShopifyVariants(1, 50));
};

/**
 * Change pagination
 */
export const onChangePagination = (page, pageSize) => async (dispatch) => {
    dispatch({
        type: SET_VARIANTS_PAGINATION,
        payload: { page, pageSize }
    });

    dispatch(fetchShopifyVariants(page, pageSize));
};

/**
 * Update single variant
 */
export const updateVariant = (variantId, updateData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPDATE_VARIANT_REQUEST });

        const response = await api.put(`/shopify/variants/${variantId}`, updateData);

        dispatch({
            type: UPDATE_VARIANT_SUCCESS,
            payload: response.data.data
        });

        // Refresh list
        const state = getState();
        dispatch(fetchShopifyVariants(
            state.shopifyVariants.pagination.current,
            state.shopifyVariants.pagination.pageSize
        ));

        return response.data;
    } catch (error) {
        dispatch({
            type: UPDATE_VARIANT_FAILURE,
            payload: error.response?.data?.message || 'Failed to update variant'
        });
        throw error;
    }
};

/**
 * Bulk update variants
 */
export const bulkUpdateVariants = (variantIds, updateData) => async (dispatch, getState) => {
    try {
        dispatch({ type: BULK_UPDATE_VARIANTS_REQUEST });

        const response = await api.post('/shopify/variants/bulk-update', {
            variantIds,
            updateData
        });

        dispatch({
            type: BULK_UPDATE_VARIANTS_SUCCESS,
            payload: response.data
        });

        // Refresh list
        const state = getState();
        dispatch(fetchShopifyVariants(
            state.shopifyVariants.pagination.current,
            state.shopifyVariants.pagination.pageSize
        ));

        return response.data;
    } catch (error) {
        dispatch({
            type: BULK_UPDATE_VARIANTS_FAILURE,
            payload: error.response?.data?.message || 'Failed to bulk update variants'
        });
        throw error;
    }
};
